import * as d3 from 'd3'

import { IndicatorType } from '../constants/common'
import { getBarWidthWithMarginByParts } from '../utils/chart'
import { drawInVisibleArea } from '../utils/draw_in_visible_area'
import Indicator from './indicator'

class Volume extends Indicator {
  static type = IndicatorType.Vol
  static label = 'Volume'

  compute() {
    const { min, max } =
      this.data.volume.length > 0 ? this.computeVisibleMinMax(this.data.volume) : this.getDomainDefaults(this.type)
    this.min = min
    this.max = max
  }

  renderIndicator(context: CanvasRenderingContext2D) {
    const { ChartSettings } = this.getChartLayoutSettings()
    const { Colors } = ChartSettings.general
    const chartModel = this.model.chart()
    const { zoomFactor } = chartModel
    const { barFillWidth, barBorderWidth } = getBarWidthWithMarginByParts({
      zoomFactor,
      chartLayout: chartModel.chart_layout(),
    })
    const barWidthWithoutMargin = barFillWidth + barBorderWidth * 2
    const halfBarWidth = ~~Math.max(1, barWidthWithoutMargin / 2)

    drawInVisibleArea(
      this.data.volume,
      0,
      (x) => this.fx(x) - halfBarWidth,
      this.leftOffset,
      this.width,
      (i, x) => {
        context.fillStyle = this.data.close[i] < this.data.open[i] ? Colors.volumeTrendDown : Colors.volumeTrendUp
        const y = Math.round(this.fy(this.data.volume[i]))
        context.fillRect(x, y, barWidthWithoutMargin, context.canvas.height - y)
      }
    )
  }

  formatAxis(value: number) {
    const format = d3.scaleLinear().domain(this.model.scale.y.domain()).tickFormat(4, 's')
    return format(value).replace(/G/, 'B') // https://github.com/d3/d3-format/blob/master/README.md#locale_formatPrefix
  }

  getModalConfig() {
    return {
      title: this.label,
      inputs: [],
      inputsErrorMessages: {},
    }
  }

  toString() {
    return `Volume`
  }
}

export default Volume
